import {formatTimestamp, toDate} from '../../../utils/formatTimestamp';

/**
 * Convert Firestore timestamp to formatted date-time string.
 * @param {Object} timestamp - Firestore timestamp object
 * @returns {string} - Formatted date-time string
 */
export const firestoreTimestampToDateTime = (timestamp) => formatTimestamp(timestamp, '-');

/**
 * Format various value types for display.
 * @param {*} value - Value to format
 * @returns {string} - Formatted value
 */
export const formatValue = (value) => {
    if (value === null || value === undefined) return '-';

    // Any date-like value (Firestore Timestamp, Date, ISO string)
    const d = toDate(value);
    if (d) return formatTimestamp(d, '-');

    // Otherwise return as-is (strings, numbers)
    return String(value);
};

/**
 * Get nested value from object using dot notation path
 * @param {Object} obj - Object to get value from
 * @param {string} path - Dot notation path (e.g., 'user.profile.name')
 * @returns {*} - Value at path or undefined
 */
export const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    return path.split('.').reduce(
        (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
        obj
    );
};
